<template>
  <div class="data-panel">
    <h3 class="data-title">Notas Internas</h3>
    <div v-if="loading" style="color:#6b7280;font-size:14px;">Carregando...</div>
    <div v-else class="data-settings">
      <div class="data-field" style="max-width:600px;">
        <label>Anotações (visíveis apenas para master admins)</label>
        <textarea v-model="internalNotes" rows="10" style="padding:10px;border:1.5px solid #d1d5db;border-radius:8px;font-size:14px;resize:vertical;outline:none;font-family:inherit;" />
      </div>
      <p v-if="notesError" class="data-error">{{ notesError }}</p>
      <p v-if="notesSuccess" class="data-success">{{ notesSuccess }}</p>
      <button class="btn-admin-primary" type="button" :disabled="notesSaving" @click="saveNotes">
        {{ notesSaving ? 'Salvando...' : 'Salvar notas' }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, inject, onMounted } from 'vue'
import { masterFetch } from '@/store/masterSession'

export default {
  name: 'AdminSysNotesTab',
  setup() {
    const detail = inject<any>('adminDetail')

    const loading = ref(false)
    const internalNotes = ref('')
    const notesSaving = ref(false)
    const notesError = ref('')
    const notesSuccess = ref('')

    const loadNotes = async () => {
      if (!detail?.value) return
      loading.value = true
      try {
        const n = await masterFetch<{ internalNotes: string }>(`/master/systems/${detail.value.systemId}/notes`)
        internalNotes.value = n.internalNotes || ''
      } catch { /* ignore */ } finally {
        loading.value = false
      }
    }

    onMounted(loadNotes)

    const saveNotes = async () => {
      notesError.value = ''
      notesSuccess.value = ''
      if (!detail?.value) return
      notesSaving.value = true
      try {
        await masterFetch(`/master/systems/${detail.value.systemId}/notes`, {
          method: 'PUT',
          body: JSON.stringify({ internalNotes: internalNotes.value })
        })
        notesSuccess.value = 'Notas salvas.'
      } catch (err: unknown) {
        notesError.value = err instanceof Error ? err.message : 'Erro ao salvar.'
      } finally {
        notesSaving.value = false
      }
    }

    return { loading, internalNotes, notesSaving, notesError, notesSuccess, saveNotes }
  }
}
</script>

<style lang="scss">
/* Shared styles — defined in AdminSysDataTab */
</style>
